var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { staticClass: "root", attrs: { tag: "w-list" } },
    _vm._l(_vm.purchase.Ledgers, function (ledger, i) {
      return _c(
        "w-list-item",
        { key: i },
        [
          _c("w-list-item-text", [
            _c("div", [_vm._v(_vm._s(_vm.ledgerToText(ledger)))]),
            _c("div", { staticClass: "comment" }, [
              _vm._v(_vm._s(ledger.Comment) + "​"),
            ]),
          ]),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }